import React from 'react';
type MiniSliderProps = {
  id: string;
  label: string;
  unit: string;
  min: number;
  max: number;
  step?: number;
  value: number;
  onChange: (value: number) => void;
};
export function MiniSlider({
  id,
  label,
  unit,
  min,
  max,
  step = 1,
  value,
  onChange
}: MiniSliderProps) {
  const frac = (value - min) / (max - min);
  const at = `calc(10px + ${frac} * (100% - 20px))`;
  return <div className="flex max-w-[320px] items-center gap-3" data-id="element-181" data-mp="dys30tzztuib">
      <span className="w-7 shrink-0 text-right font-mono text-[11px] tabular-nums text-graphite/60" aria-hidden="true" data-id="element-182" data-mp="e1ec4y2j8i2n">
        {min}
      </span>
      <div className="relative h-8 flex-1 select-none" data-id="element-183" data-mp="nxreekc58490">
        <span className="pointer-events-none absolute inset-x-[10px] top-1/2 h-[2px] -translate-y-1/2 rounded-full bg-rule" data-id="element-184" data-mp="nv4vxpnps4c0" />
        <span className="pointer-events-none absolute left-[10px] top-1/2 h-[2px] -translate-y-1/2 rounded-full bg-ink" style={{
        width: `calc(${frac} * (100% - 20px))`
      }} data-id="element-185" data-mp="1zcefec6uewdb" />
        <input id={id} type="range" min={min} max={max} step={step} value={value} onChange={e => onChange(Number(e.target.value))} aria-label={label} aria-valuetext={`${value} ${unit}`} className="precision-range peer absolute inset-0 z-10 h-full w-full cursor-grab active:cursor-grabbing" data-id="element-186" data-mp="3u8zwg432w35e" />
        <span className="pointer-events-none absolute top-1/2 h-3.5 w-3.5 -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white bg-ink shadow-[0_0_0_1px_rgba(28,29,34,0.9)] peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-offset-4 peer-focus-visible:outline-accent" style={{
        left: at
      }} data-id="element-187" data-mp="3bis0q71pkez8" />
      </div>
      <span className="w-7 shrink-0 font-mono text-[11px] tabular-nums text-graphite/60" aria-hidden="true" data-id="element-188" data-mp="2srs6aqbg2cyk">
        {max}
      </span>
    </div>;
}